import FirestoreModel from './FirestoreModel'
import { dateformat, equal, gte, number, required, string } from 'vue-mc/validation'

export default class Trip extends FirestoreModel {
  modelName = 'Trip'
  collection = 'trips'
  autoFields = true

  defaults () {
    return {
      id: null,
      name: '',
      startDate: '',
      endDate: '',
      cost: 0,
      image: null,
      backgroundColor: null,
      textColor: null,
      users: {},
      countries: [],
      visibility: 'private'
    }
  }

  mutations () {
    return {}
  }

  validation () {
    return {
      name: required.and(string),
      startDate: dateformat('yyyy-MM-dd').or(equal('')).or(equal(null)),
      endDate: dateformat('yyyy-MM-dd').or(equal('')).or(equal(null)),
      cost: number.and(gte(0)),
      image: string.or(equal(null))
    }
  }
}
